import React, { useCallback, useContext, useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { GET_DASHBOARD_TOP_PORT } from "../../services/apiRoutes";
import { AuthContext } from "../../context/AuthContext";
import { Card, CardHeader } from "@mui/material";
import { genericPost } from "../../services/authServices";
import { t } from "../../constants/translationHelper";


const ChartTemplate = ({ labels, series }) => {

    const colors = [
        '#8900CD',
        '#003B88',
        '#003399',
        '#FF7145',
        '#265060',
        '#261CC1',
        '#185DA7',
        '#3A9AFF',
        '#1C0770',
        '#0671FF',
    ];
    const chartSeries = [
        {
            data: series
        }
    ];

    const options = {
        chart: {
            type: "bar",
            height: 300
        },

        colors: colors,

        plotOptions: {
            bar: {
                columnWidth: "45%",
                distributed: true,
                borderRadius: 4
            }
        },

        dataLabels: {
            enabled: false
        },

        legend: {
            show: false
        },

        xaxis: {
            categories: labels,
            labels: {
                style: {
                    colors: colors,
                    fontSize: "11px"
                }
            }
        },

        yaxis: {
            labels: {
                formatter: function (val) {
                    return val.toLocaleString();
                }
            }
        },

        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " Containers";
                }
            }
        }
    };

    return (
        <div>
            {series.length === 0 ? (
                <p>Loading...</p>
            ) : (
                <ReactApexChart
                    options={options}
                    series={chartSeries}
                    type="bar"
                    height={300}
                />
            )}
        </div>
    );
};
const TopPortOfDestination = () => {
    const [topPorts, setTopPorts] = useState([]);
    const { token } = useContext(AuthContext);
    const [labels, setLabels] = useState([]);
    const [series, setSeries] = useState([]);

    const fetchData = useCallback(async () => {
        try {
            const payload = { commanShipmentId: 1 };
            const response = await genericPost(GET_DASHBOARD_TOP_PORT, payload);

            if (response.data.success && response.data.data?.portOfDestination) {
                const ports = response.data.data.portOfDestination;
                setTopPorts(ports);

                // Prepare chart data
                const chartLabels = ports.map(p => p.destination?.portName || "Unknown");
                const chartSeries = ports.map(p => Number(p.totalContainers));
                setLabels(chartLabels);
                setSeries(chartSeries);
            }
        } catch (error) {
            console.error("Error fetching Top Port Of Destination data", error);
        }
    }, []);


    useEffect(() => {
        fetchData();
    }, [fetchData, token]);

    return (
        <>
            <Card variant="outlined"
                style={{ display: "flex", gap: "10px" }}>
                <div
                    style={{ flex: 1, padding: "0px", width: "50%" }}
                >
                    <ChartTemplate
                        title={t("Top Supplier")}
                        labels={labels}
                        series={series}
                    />
                </div>
                <div
                    style={{ flex: 1, padding: "0px", width: "50%" }}
                >
                    <CardHeader title={t("Top Port Of Destination")} titleTypographyProps={{
                        fontWeight: 700,
                        fontSize: "16px"
                    }} />
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            textAlign: "left",
                        }}
                    >
                        <tbody>
                            {topPorts.length > 0 ? (
                                topPorts.map((row, index) => {
                                    const color = rowColors[index % rowColors.length];

                                    return (
                                        <React.Fragment key={index}>
                                            <tr
                                                style={{
                                                    borderBottom: "1px solid #eee",
                                                    backgroundColor: color,
                                                    color: "#fff",
                                                    height: "30px",


                                                }}
                                            >
                                                <td style={{ padding: "5px", fontSize: "12px", paddingLeft: "18px", }}>
                                                    {row.destination?.portName || ""},{" "}
                                                    {row.destination?.country?.name || ""}
                                                </td>

                                                <td style={{ padding: "5px", fontSize: "12px" }}>
                                                    {row.totalContainers} - Containers
                                                </td>
                                            </tr>

                                            <tr style={{ height: "30px" }}></tr>
                                        </React.Fragment>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ padding: "10px", textAlign: "center" }}>
                                        {t("No data available")}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

            </Card>
        </>
    );
};

export default TopPortOfDestination;


const rowColors = [
    '#8900CD',
    '#003B88',
    '#003399',
    '#FF7145',
    '#265060',
    '#261CC1',
    '#185DA7',
    '#3A9AFF',
    '#1C0770',
    '#0671FF',
];